var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs__item",class:{active: _vm.mode === _vm.type},on:{"click":function($event){return _vm.changeMode(_vm.type)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }